module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ko":{"no_video_data":"등록된 동영상이 없습니다.","no_video_reviews":"동영상 리뷰가 없습니다."}}')
  delete Component.options._Ctor
}
